<div class="govuk-width-container">
    <div class="row">
        <nav class="col-12 col-md-4" aria-label="Side navigation">
            <p class="govuk-body h-100"><app-menu></app-menu></p>
        </nav>
        <main class="govuk-main-wrapper col-12 col-md-8 pt-0" id="main-content" tabindex="-1">
            <h1 class="govuk-heading-xl">Ceremony Communication</h1>

            <div class="govuk-notification-banner app-notification-banner" role="region" aria-labelledby="new-service-options-title"
                data-module="govuk-notification-banner" data-test="new-service-options">
                <div class="govuk-notification-banner__header">
                    <h2 class="govuk-notification-banner__title" id="new-service-options-title">
                        Important
                    </h2>
                </div>
                <div class="govuk-notification-banner__content">
                    <p class="govuk-notification-banner__heading">
                        We've introduced new service options and are monitoring everything closely to ensure it runs smoothly. If you notice
                        anything unexpected, please let us know through the ceremony portal. We may also contact you to confirm everything has
                        gone through successfully.
                    </p>
                </div>
            </div>

            <app-custom-object-banner page="communication"></app-custom-object-banner>

            <ng-container *ngIf="messages.length > 0">
                <table class="govuk-table">
                    <caption class="govuk-table__caption govuk-table__caption--m">Updates regarding your ceremony</caption>
                    <thead class="govuk-table__head">
                        <tr class="govuk-table__row">
                            <th scope="col" class="govuk-table__header govuk-!-width-one-quarter">From</th>
                            <th scope="col" class="govuk-table__header govuk-!-width-one-quarter">Query reason</th>
                            <th scope="col" class="govuk-table__header">Message</th>
                            <!-- <th scope="col" class="govuk-table__header govuk-!-width-one-quarter">Status</th> -->
                            <th scope="col" class="govuk-table__header">Sent at</th>
                        </tr>
                    </thead>
                    <tbody class="govuk-table__body">
                        <tr class="govuk-table__row" *ngFor="let message of messages">
                            <th scope="row" class="govuk-table__header">{{ (message.sender_id == 1) ? 'Westminster' : member.first_name + ' ' + member.last_name }}</th>
                            <td class="govuk-table__cell">{{ (message.category) ? message.category : '' }}</td>
                            <td class="govuk-table__cell" [innerHTML]="message.message"></td>
                            <!-- <td class="govuk-table__cell"><strong class="govuk-tag" [ngClass]="{'govuk-tag--green': !message.read_at, 'govuk-tag--blue': message.read_at}">{{ message.read_at? 'Read' : 'Sent' }}</strong></td> -->
                            <td class="govuk-table__cell">
                                {{ message.created_at | date: 'medium' }}
                                <!-- <details class="govuk-details">
                                    <summary class="govuk-details__summary" aria-label="view timeline of message status">
                                        <span class="govuk-details__summary-text">
                                        View timeline
                                        </span>
                                    </summary>
                                    <div class="govuk-details__text">
                                        <div>
                                            <strong>Sent at</strong>: {{ message.created_at | date: 'medium' }}
                                        </div>
                                        <div *ngIf="message.read_at">
                                            <strong>Read at</strong>: {{ message.read_at | date: 'medium' }}
                                        </div>
                                        <div *ngIf="message.read_at">
                                            <strong>Read by</strong>: {{ (message.sender_id == 1) ?  member.first_name + ' ' + member.last_name : 'Westminster'}}
                                        </div>
                                    </div>
                                </details> -->
                            </td>
                            </tr>
                    </tbody>
                </table>
            </ng-container>
            <ng-container *ngIf="messages.length < 1">
                <p>No messages so far.</p>
            </ng-container>
            <p class="govuk-body">
                <button type="button" class="govuk-button govuk-button--secondary" data-module="govuk-button" (click)="openSendMessage()" *ngIf="!sendingMessage">Send a new message</button>
            </p>
            <ng-container *ngIf="sendingMessage">
                <form [formGroup]="sendingForm" class="message-form">
                    <div class="govuk-form-group" [ngClass]='{"govuk-form-group--error": sendingForm.touched && form.message?.errors?.required && sendingFormSubmitted}'>
                        <h2 class="govuk-label-wrapper">
                            <label class="govuk-label govuk-label--s" for="message">
                            <i class="ph ph-paper-plane-tilt" aria-hidden="true"></i>
                            Message us
                            </label>
                        </h2>
                        <p id="more-detail-error" class="govuk-error-message" *ngIf="sendingForm.touched && form.message?.errors?.required && sendingFormSubmitted">
                            <span class="govuk-visually-hidden">Error:</span> Please enter your message
                        </p>
                        <textarea aria-required="true" class="govuk-textarea" id="message" name="message" rows="5" [attr.aria-describedby]="sendingForm.touched && form.message?.errors?.required && sendingFormSubmitted? 'more-detail-error' : null" formControlName="message" placeholder="Enter your message to the service here"></textarea>
                    </div>
                    <ng-container *ngIf="sendingFormCategories.length > 0">
                        <div class="govuk-form-group" [ngClass]='{"govuk-form-group--error": sendingForm.touched && form.category?.errors?.required && sendingFormSubmitted}'>
                            <label class="govuk-label" for="sort">
                                Please select from the list, what your query relates to:
                            </label>
                            <p id="category-error" class="govuk-error-message" *ngIf="sendingForm.touched && form.category?.errors?.required && sendingFormSubmitted">
                                <span class="govuk-visually-hidden">Error:</span> Please select what your query relates to
                            </p>
                            <select aria-required="true" class="govuk-select" id="sort" name="category" formControlName="category" [attr.aria-describedby]="sendingForm.touched && form.category?.errors?.required && sendingFormSubmitted ? 'category-error' : null" [ngClass]='{"govuk-select--error": sendingForm.touched && form.agree?.errors?.required}'>
                                <option value=""></option>
                                <ng-container *ngFor="let opt of sendingFormCategories">
                                    <option [value]="opt">{{ opt }}</option>
                                </ng-container>
                            </select>
                        </div>
                    </ng-container>
                    <div class="govuk-form-group" [ngClass]='{"govuk-form-group--error": sendingForm.touched && form.agree?.errors?.required && sendingFormSubmitted}'>
                        <p id="agree-error" class="govuk-error-message" *ngIf="sendingForm.touched && form.agree?.errors?.required && sendingFormSubmitted">
                            <span class="govuk-visually-hidden">Error:</span> Please ensure you have reviewed the 'Frequently Asked Questions' before submitting
                        </p>
                        <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                            <div class="govuk-checkboxes__item">
                                <input aria-required="true" class="govuk-checkboxes__input" id="agree" name="agree" type="checkbox" formControlName="agree">
                                <label class="govuk-label govuk-checkboxes__label" for="agree">
                                    I have reviewed the 'Frequently Asked Questions' to check if the answer to my query is already available.
                                </label>
                                </div>
                        </div>
                    </div>
                    <div class="govuk-form-group">
                        <div class="govuk-button-group">
                            <button type="button" class="govuk-button govuk-button--secondary" data-module="govuk-button" (click)="sendMessage()" >Send <i class="ph ph-arrow-right" aria-hidden="true"></i></button>
                            <button type="submit" class="govuk-button govuk-button--secondary" data-module="govuk-button" (click)="closeMessage()">
                                Cancel
                            </button>
                        </div>
                    </div>
                </form>
            </ng-container>
        </main>
    </div>
</div>
